import { render, staticRenderFns } from "./uni-rate.vue?vue&type=template&id=16b7e26f&"
import script from "./uni-rate.vue?vue&type=script&lang=js&"
export * from "./uni-rate.vue?vue&type=script&lang=js&"
import style0 from "./uni-rate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b7e26f')) {
      api.createRecord('16b7e26f', component.options)
    } else {
      api.reload('16b7e26f', component.options)
    }
    module.hot.accept("./uni-rate.vue?vue&type=template&id=16b7e26f&", function () {
      api.rerender('16b7e26f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uni-rate/uni-rate.vue"
export default component.exports